// hooks/useExternalLogin.ts
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { ExternalAccountLogin } from '../services/externalAccount.service';
import { ApiResultModel } from '../models/common.model';
import { ICheckOtpResponse } from '../models/account.model';
import { setJwtToken } from '../services/auth.service';

export const useExternalLogin = () => {
    const navigate = useNavigate();
    //route from kaman
    const {
        mutate: externalLogin,
        isLoading: loadingExternalLogin,
        error,
    } = useMutation(ExternalAccountLogin, {
        onSuccess: (data: ApiResultModel<ICheckOtpResponse>) => {
            if (data.isSuccess && data.data?.jwt) {
                setJwtToken(data.data.jwt!, data.data.refreshToken);
                const url = new URL(window.location.href);
                url.searchParams.delete('token');
                const search = url.searchParams.toString();
                window.history.replaceState(
                    window.history.state,
                    '',
                    `/${search ? `?${search}` : ''}${url.hash}`
                );
                navigate('/home', {replace: true});
            }
        },
    });

    return {
        externalLogin,
        loadingExternalLogin,
        error,
    };
};
